// extracted by mini-css-extract-plugin
module.exports = {"colorLight":"#fff","colorSelect":"#d9d9d9","colorPrimary":"#04223b","statusBarPrimaryColor":"#000","statusBarSecondaryColor":"#c5c5c5"};